import React from "react";
import { ButtonProps } from "./SolidButton";

import spinnerSvg from "../../assets/svg/spinner-blue.svg";

export const OutlineButton: React.FC<ButtonProps> = ({
  onClick,
  children,
  outlineColor,
  textSize,
  loading,
  width,
  disabled,
  stopPropagation,
  roundedSize,
  hoverColor,
  hoverFont,
}) => {
  return (
    <button
      onMouseDown={stopPropagation ? (e) => e.stopPropagation() : undefined}
      disabled={disabled}
      onClick={onClick}
      className={`px-2 md:px-2 py-2 text-sm ${width} text-${outlineColor} border-2 border-${outlineColor} focus:bg-${outlineColor} focus:text-white  hover:bg-${outlineColor} ${textSize} hover:text-white hover:text-${hoverColor} hover:font-${hoverFont} transition duration-500 ease-in-out rounded-${
        roundedSize ? roundedSize : "sm"
      } whitespace-nowrap`}
    >
      {loading ? (
        <div className="flex items-center justify-center min-w-full">
          <img
            className="h-5 animate-spin"
            src={spinnerSvg}
            alt="loading spinner"
          />
        </div>
      ) : (
        children
      )}
    </button>
  );
};
